module.exports = "https://www.gc-qa.gnp.com.mx/0d419435e035605038e60de21048f826.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-consulta.svg
// module id = 1824
// module chunks = 0